import { VideosService } from './../../services/videosService';
import { QuestionsService } from './../../../questions/services/questionsService';
import { ServicesService } from './../../../services/services/servicesService';
import { Component, OnInit, Input } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddVedioComponent } from '../add-vedio/add-vedio.component';
import { UpdateVedioComponent } from '../update-vedio/update-vedio.component';

@Component({
  selector: 'ngx-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
})
export class VideoComponent implements OnInit {
  @Input() servicesHistories;
  @Input() serviceId;
  constructor(private diag: NbDialogService, private service: ServicesService, private toast: NbToastrService,
    private qService: VideosService) {}

  ngOnInit() {}
  addnewVideo() {
    this.diag.open(AddVedioComponent, { context: { serviceId: this.serviceId } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.service.getById(this.serviceId).subscribe((resp) => {
          this.servicesHistories = resp.servicesHistories;
        });
      }
    });
  }
  update(question) {
    this.diag.open(UpdateVedioComponent, { context: { videos: question } }).onClose.subscribe((res) => {
      if (res === 'true') {
        this.service.getById(this.serviceId).subscribe((resp) => {
          this.servicesHistories = resp.servicesHistories;
        });
      }
    });
  }
  delete(id) {
    this.qService.delete(id).subscribe((res) => {
      this.toast.show('تم حذف الفيديو بنجاح', '', { status: 'success', duration: 3000 });

      this.service.getById(this.serviceId).subscribe((resp) => {
        this.servicesHistories = resp.servicesHistories;
      });
    });
  }
}
